export function findParentByAttribute(node, attribute) {
    while ((node = node.parentElement) && !node.getAttribute(attribute));
    return node;
}

export function getLinkTargetUrl(node) {
    const href = node.getAttribute('href');
    const origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;

    if (href && !href.match(/^http/)) {
        return `${origin}${href}`;
    }

    return href;
}

export function getLinkTargetPath(node) {
    const href = node.getAttribute('href');

    if (href && href.match(/^http/)) {
        return href.replace(/^http[s]{0,1}:\/\/.[^\/]+[\/]*/, '/');
    }

    return href;
}



// WEBPACK FOOTER //
// ./js/common/utils/domUtils.js